import { AppLayout } from "@bcc/components/app-layout";
import { SearchView } from "@bcc/components/views/search-view";

export function SearchPage() {
  return (
    <AppLayout>
      <SearchView />
    </AppLayout>
  );
}
